
<template>
  <main class="component-main single-card-outer">
    <card-component :did="room.did" :room="room"></card-component>
  </main>
</template>

<script>

import Card from '@/components/card/Frame';

export default {

  data(){
    return {

    }
  },

  components: {
    'card-component': Card
  },

  computed: {
    room(){
      return this.$store.getters.getActiveRoom();
    }
  },

  watch: {
    '$screen.breakpoint': function(newData, oldData){
      if (newData === 'lg') this.$router.push({path: `/room/${this.$store.state.roomIndex}`});
    }
  }

}

</script>

<style>

.single-card-outer {

}

</style>



// WEBPACK FOOTER //
// src/components/room/Card.vue